import axios from '@/axios';
import { faTirePressureWarning } from '@fortawesome/pro-duotone-svg-icons';

export default {
  data() {
    return {
      showPdfReader: false,
      pdfReaderSrc: null,
      usePdfPreview: false,
      customOfflineRatersEndpoint: null,
    }
  },
  methods: {
    downloadConfirm(params) {
      const { documentGuid } = params;
      if (documentGuid.length === 0) {
        this.$vs.notify({
          title: this.$t('ErrorOccurred'),
          text: this.$t('DownloadNoItemsSelectedMessage'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          position: 'top-right'
        });

        return;
      }
      
      if (documentGuid.length > 10) {
        this.$vs.notify({
          title: this.$t('ErrorOccurred'),
          text: this.$t('DownloadMaxItemsError'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          position: 'top-right'
        });

        return;
      }

      this.$vs.dialog({
        type: 'confirm',
        title: this.$t('ConfirmDownload'),
        text: this.$t('ConfirmDownloadMessage'),
        accept: () => this.multiDownload(params),
        acceptText: this.$t('Download'),
      });
    },
    async download(params) {
      console.log("Do download with following params: ", params);

      try {
        const file = await this.getDownloadInfo(params)

        this.getFile(file)

      } catch (e) {
        console.log(e);
      }
    },

    async getDownloadAllFile() {
      this.showDownloadPopup = true;
      this.downloadingAll = true;

      try {
        this.downloadFile = await this.getAllFilesDownloadInfo();
        this.downloadAllSuccess = true;

      } catch (e) {
        console.log(e);
        this.downloadAllSuccess = false;
      }

      this.downloadingAll = false;
    },
    async downloadAll(file) {
      this.showDownloadPopup = true;

      try {
        await this.getAllFiles(file)
      } catch (e) {
        console.log(e);
        this.downloadAllSuccess = false;
      }
    },
    async getFile(file) {
      try {
        // const { data } = await axios.get('/dummy.download.pdf');
        const { data } = await axios.get(file.DocumentDownloadUrl,  { responseType: 'arraybuffer' });
        const blob = new Blob([data], { type: this.getFileType(file.Extension) });
        const filename = file.FriendlyName + '.' + file.Extension;
        const link = document.createElement('a');

        link.href = URL.createObjectURL(blob);

        console.log(file.Extension);

        if (this.usePdfPreview && file.Extension === 'pdf') {
          // Check if we are using the PdfReader component
          if (document.getElementById('pdf-reader')) {
            this.showPdfReader = true;
            this.pdfReaderSrc = file.DocumentDownloadUrl;

            return true;
          }

          link.target = '_blank';
          link.href = file.DocumentDownloadUrl;
        } else {
          link.download = filename;
        }

        link.click();

        URL.revokeObjectURL(link.href);
      } catch (e) {
        this.$vs.notify({
          title: this.$t('ErrorOccurred'),
          text: this.$t('DownloadFileFailureMessage'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          position: 'top-right'
        });
      }
    },
    async getAllFiles(file) {
      try {
        //const { data } = await axios.get('/dummy.download.pdf');
        const { data } = await axios.get(file.DocumentDownloadUrl,  { responseType: 'arraybuffer' });
        const blob = new Blob([data], { type: this.getFileType(file.Extension) })
        const filename = file.FriendlyName + '.' + file.Extension;
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = filename
        link.click()
        URL.revokeObjectURL(link.href)
      } catch (e) {
        this.downloadAllSuccess = false;
        console.log(e);
        // this.$vs.notify({
        //   title: this.$t('ErrorOccurred'),
        //   text: this.$t('DownloadFileFailureMessage'),
        //   iconPack: 'feather',
        //   icon: 'icon-alert-circle',
        //   color: 'danger',
        //   position: 'top-right'
        // });
      }
    },
    async getDownloadInfo(params) {
      const apiParams = this.getParams(params);

      try {
        const { data } = await this.$api[params.documentType].list({params: apiParams});

        return data.data;
      } catch (e) {
        this.$vs.notify({
          title: this.$t('ErrorOccurred'),
          text: this.$t('DownloadFileFailureMessage'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          position: 'top-right'
        });
      }
    },
    async getAllFilesDownloadInfo() {
      let data = {};

      if (this.customOfflineRatersEndpoint) {
        ({ data } = await this.customOfflineRatersEndpoint);
      } else {
        ({ data } = await this.$api.underwritingTools.getOfflineRaters());
      }

      return data.data;
    },
    async multiDownload(params) {
      console.log("Get download link params: ", params);

      try {
        const file = await this.getDownloadInfo(params)

        if (file.EmailReturn) {
          this.$vs.dialog({
            type: 'alert',
            title: this.$t('Download'),
            text: this.$t('DownloadEmailSuccessMessage'),
            acceptText: this.$t('Close'),
          });
        } else {
          this.$vs.dialog({
            type: 'alert',
            title: this.$t('Download'),
            text: this.$t('DownloadSuccessMessage'),
            accept: () => this.getFile(file),
            acceptText: this.$t('Download'),
          });
        }
      } catch (e) {
        console.log(e);
      }
    },
    getParams(params) {
      const { documentType, documentGuid, documentTypeId } = params;

      let returnParams = {};

      // additional params
      switch(documentType) {
        case 'policyCertificate':
          returnParams = this.formatGuidsForApi(params.documentGuid);
          break;

        case 'salesDocument':
          returnParams = {
            documentTypeId: documentTypeId,
            documentGuid: documentGuid,
          };
          break;

        default:
          break;
      }

      return returnParams;
    },
    formatGuidsForApi(guids) {

      let data = {};
      for (const key in guids) {
        data['documentGuid[' + key + ']'] = guids[key];
      }

      return data;
    },
    getFileType(extension) {
      let fileType;
      switch (extension) {

        default:
          fileType = 'application/' + extension;
          break;
      }

      return fileType;
    }
  },
};
